import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as XLSX from 'xlsx';

@Injectable({
	providedIn: 'root'
})
export class UtilityService {
	constructor() { }

	public exportAsExcelFile(data: any[], fileName: string): void {
		const workSheet = XLSX.utils.json_to_sheet(data);
		let titleRow = workSheet.addRow([""]);
		let workBook: XLSX.WorkBook = XLSX.utils.book_new();
		let wccols = [
			{ wch: 50, bold: true },
			{ wch: 50 },
			{ wch: 50 }
		];
		workSheet["!cols"] = wccols;
		XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
		XLSX.writeFile(workBook, fileName + '.xlsx');
	}

	getOrderDay(date: any) {
		let dateDisplayFormat = 'MM/DD/YYYY';
		let baseDate = new Date();
		let orderDay = '';
		let referenceDate = moment(new Date(date)).format(dateDisplayFormat);
		let today = moment(baseDate).format(dateDisplayFormat);
		let tomorrow = moment(new Date().setDate(baseDate.getDate() + 1)).format(dateDisplayFormat);
		let yesterday = moment(new Date().setDate(baseDate.getDate() - 1)).format(dateDisplayFormat)
		switch (referenceDate) {
			case today:
				orderDay = 'Today';
				break;
			case tomorrow:
				orderDay = 'Tomorrow';
				break;
			case yesterday:
				orderDay = 'Yesterday';
				break;
			default:
				orderDay = moment(new Date(referenceDate)).format('MM/DD');
				break;
		}
		return orderDay;
	}

	public setCustomerAccTimeZone(customerAccount: any, timeZones: any) {
		var accounttimezoneDetail = timeZones;
		if (accounttimezoneDetail) {
			return accounttimezoneDetail.find((obj: any) => obj.timeZoneNum == customerAccount.timeZoneNum);
		}
	}
}
